import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card h-90 border" }
const _hoisted_2 = { class: "card-header py-4" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-semibold text-gray-900 fs-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 mt-2 fw-normal fs-6" }, "Configure los detalles de las pruebas para el atleta.", -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = {
  key: 0,
  class: "atletismo"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = {
  key: 0,
  class: "me-1"
}
const _hoisted_18 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-2x" }, null, -1)
const _hoisted_20 = { class: "d-flex gap-2 align-items-center my-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-checklist text-primary fs-2" }, null, -1)
const _hoisted_22 = { class: "h4 m-0" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = {
  key: 0,
  class: "me-1"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-1 text-hover-danger cursor-pointer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('acrd2')), 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.idformfield,
              class: "mb-3"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", null, _toDisplayString(field.field_label), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_form_item, {
                    prop: `fields.${field.field_name}`,
                    rules: [
                                {
                                    required: field.required == 1 ? true : false,
                                    message: 'Este campo es requerido',
                                    trigger: ['blur', 'change'],
                                },
                            ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.fields[field.field_name],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.fields[field.field_name]) = $event),
                        maxlength: field.field_length,
                        placeholder: `Ingrese ${field.field_label}`
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ])
              ])
            ]))
          }), 128)),
          (_ctx.idsport == '2' || _ctx.idsport == '10' || _ctx.idsport == '11' || _ctx.idsport == '28' || _ctx.idsport == '15'
                    || _ctx.idsport == '25' || _ctx.idsport == '19' || _ctx.idsport == '12' || _ctx.idsport == '13' || _ctx.idsport == '9' 
                    || _ctx.idsport == '8' || _ctx.idsport == '24' || _ctx.idsport == '14')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_form_item, {
                      prop: "cmp",
                      label: _ctx.t('competence'),
                      class: "fw-bold text-black",
                      rules: [
                                    {
                                        required: false,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.cmp,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.cmp) = $event)),
                          filterable: "",
                          placeholder: _ctx.t('seleccione'),
                          onChange: _ctx.getCompetencia,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.cmp, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_form_item, {
                      prop: "idniv",
                      label: _ctx.t('categorie'),
                      class: "fw-bold text-black",
                      rules: [
                                    {
                                        required: false,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idniv,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idniv) = $event)),
                          filterable: "",
                          placeholder: _ctx.t('seleccione'),
                          size: "large",
                          onChange: _ctx.getTest
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.nv, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_form_item, {
                      prop: "idtest",
                      label: _ctx.t('modality'),
                      class: "fw-bold text-black",
                      rules: [
                                    {
                                        required: false,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.form.idtest,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.idtest) = $event)),
                          filterable: "",
                          placeholder: _ctx.t('seleccione'),
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTest, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: `lstc-${index}`,
                                label: item.name,
                                value: item.code
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_16, [
                                    (item.abrev != '' || item.abrev)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.abrev) + " - ", 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 7 || _ctx.username?.idperfil == 6)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          color: "#3B82F6",
                          onClick: _ctx.saveTest,
                          loading: _ctx.loadingTest,
                          size: "large",
                          class: "mt-3 rounded"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.t('add')) + " " + _toDisplayString(_ctx.t('modality')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('selectedTest')), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.listMiTest,
                    stripe: "",
                    class: "border rounded p-0 m-0",
                    "header-cell-class-name": "bg-light text-gray-800"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "cmp",
                        label: _ctx.t('competence')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "category",
                        label: _ctx.t('categorie')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "test",
                        label: _ctx.t('modality')
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_24, [
                            (scope.row.abrev != '' && scope.row.abrev != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(scope.row.abrev) + " - ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(scope.row.test), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        prop: "address",
                        label: "OP",
                        width: "80"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_popconfirm, {
                            effect: "dark",
                            width: "250",
                            title: `${_ctx.t('delete')} ${row?.test}?`,
                            "confirm-button-text": _ctx.t('yes'),
                            "cancel-button-text": "No",
                            "cancel-button-type": "info",
                            "confirm-button-type": "danger",
                            onConfirm: ($event: any) => (_ctx.onDeleteTest(row.id))
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 2
                          }, 1032, ["title", "confirm-button-text", "onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loadingTest]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}